<div class="content-wrapper">
    <ng-template #content>
        <div id="modal">
            <div class="modal-header font-weight-bold">
                <h4 class="modal-title font-weight-bold" *ngIf="addAddressModal">
                    <i class="fa fa-map-marker mr-10px f_18 text-danger" aria-hidden="true"></i>Add New Address
                </h4>
                <h4 class="modal-title font-weight-bold" *ngIf="updateAddressModal">
                    <i class="fa fa-map-marker mr-10px f_18 text-danger" aria-hidden="true"></i>Update Address
                </h4>
                <h4 class="modal-title font-weight-bold" *ngIf="deleteAddressModal">
                    <i class="fa fa-map-marker mr-10px f_18 text-danger" aria-hidden="true"></i>Delete Address
                    - {{selectedAddress?.name}}
                </h4>
                <h4 class="modal-title font-weight-bold" *ngIf="placeOrderModal">
                    <i class="fa fa-money mr-10px f_18 text-danger" aria-hidden="true"></i>Place Order
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                        (click)="modalService.dismissAll('')">×
                </button>
            </div>
            <div class="modal-body">
                <div class="row" *ngIf="!orderPlaced && !orderPlacing">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div class="row p-10px" *ngIf="updateAddressModal || addAddressModal">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <form class="form mt-2 mb--8px" novalidate [formGroup]="addAddressForm">
                                    <div class="row">
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>Contact Person Name</label>
                                                <input class="form-control" type="text" formControlName="name"
                                                       placeholder="Contact person Name"/>
                                                <small *ngIf="submitted && addAddressForm.get('name').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>Contact Person Phone</label>
                                                <input class="form-control" type="number" formControlName="contact"
                                                       placeholder="Contact person Phone"/>
                                                <small *ngIf="submitted && addAddressForm.get('contact').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>Address</label>
                                                <textarea class="form-control resize-none"
                                                          formControlName="address"></textarea>
                                                <small *ngIf="submitted && addAddressForm.get('address').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>City</label>
                                                <input class="form-control" type="text" formControlName="city"
                                                       placeholder="City"/>
                                                <small *ngIf="submitted && addAddressForm.get('city').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>State</label>
                                                <select class="form-control" formControlName="state_id">
                                                    <option value="">Select State</option>
                                                    <option [value]="state?.id"
                                                            *ngFor="let state of states">{{state?.name}}</option>
                                                </select>
                                                <small *ngIf="submitted && addAddressForm.get('state_id').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>Pin Code</label>
                                                <input class="form-control" type="number" formControlName="pin_code"
                                                       placeholder="Pin Code"/>
                                                <small *ngIf="submitted && addAddressForm.get('pin_code').hasError('required')"
                                                       class="text-danger">
                                                    Field is required.
                                                </small>
                                            </fieldset>
                                        </div>
                                        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                                            <fieldset class="form-group">
                                                <label>GSTIN</label>
                                                <input class="form-control" id="gst_no" placeholder="Enter GST Number" formControlName="gst_no" >
                                                <small *ngIf=" submitted && addAddressForm && addAddressForm.controls && addAddressForm.controls['gst_no'] && addAddressForm.controls['gst_no'].errors && addAddressForm.controls['gst_no'].errors.pattern"
                                                       class="text-danger">Invalid GSTIN format.</small>
                                            </fieldset>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="row p-10px text-italic" *ngIf="deleteAddressModal">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <h5>Are you sure you want to this delete address ?</h5>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {{selectedAddress.name}}
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {{selectedAddress.contact}}
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                {{selectedAddress.address}}
                            </div>
                        </div>
                        <div class="row p-10px" *ngIf="placeOrderModal">
                            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                <h5>
                                    Are you sure you want to place this order ?
                                    <br>
                                    Your Total Payable amount will be <span class="text-italic font-weight-bold">"&#8377;{{grandTotalAmount | IndianNumber}}
                                    "</span>.
                                </h5>
                                <h5><b>Select Payment Mode?</b></h5>
                                <div class="form-check form-check-inline " style="padding-top: 5px;">
                                    <input class="form-check-input" type="radio" name="wallet" id="wallet"   value="wallet" [(ngModel)]="selectedPaymentMethod"  >
                                    <label class="form-check-label" for="wallet" style="font-size:15px;font-weight: bold;">
                                        Wallet
                                    </label>
                                </div>
                                <div class="form-check form-check-inline">
                                    <input class="form-check-input" type="radio" name="online" id="online"  value="online" [(ngModel)]="selectedPaymentMethod">
                                    <label class="form-check-label" for="online" style="font-size:15px;font-weight: bold;">
                                        Online
                                    </label>
                                </div>
                              <div class="row" *ngIf="selectedPaymentMethod === 'wallet'" style="padding-top: 5px;">
                                  <div class="col-12">
                                      <span>Your wallet Amount is: &#8377; {{userData?.wallet_amount   | number:'1.2-2'}}</span>
                                  </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row p-10px" *ngIf="orderPlacing && !orderPlaced">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                        <i class="fa fa-spinner fa-spin fa-2x text-blue" aria-hidden="true"></i>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center text-italic">
                        <h5>
                            Please wait, while your order is being placed ...
                        </h5>
                    </div>
                </div>
                <div class="row p-10px" *ngIf="orderPlaced && !orderPlacing">
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                        <i class="fa fa-check-circle fa-2x text-success" aria-hidden="true"></i>
                    </div>
                    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center text-italic">
                        <h5>
                            Thank You
                        </h5>
                    </div>
                </div>
            </div>
            <div class="modal-footer p-10px" *ngIf="!orderPlaced && !orderPlacing">
                <button class="btn btn-sm btn-danger color-white mr-auto" (click)="modalService.dismissAll('')">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Cancel
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="addAddress()"
                        *ngIf="!selectedAddress && addAddressModal">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Submit
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="updateAddress()"
                        *ngIf="selectedAddress && updateAddressModal">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Update
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="deleteAddress()"
                        *ngIf="selectedAddress && deleteAddressModal">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="placeOrder()" *ngIf="placeOrderModal && selectedPaymentMethod === 'wallet' && !submitted_loader">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure wallet
                </button>
                <button class="btn btn-sm btn-primary color-white" *ngIf="placeOrderModal && selectedPaymentMethod === 'wallet' && submitted_loader">
                    <i class="fa fa-spinner mr-5px" aria-hidden="true"></i>Yes, Sure wallet
                </button>
                <button class="btn btn-sm btn-primary color-white" (click)="placeOrderOnline()" *ngIf="placeOrderModal && selectedPaymentMethod === 'online' && !submitted_loader">
                    <i class="fa fa-check-circle mr-5px" aria-hidden="true"></i>Yes, Sure online
                </button>
                <button class="btn btn-sm btn-primary color-white"  *ngIf="placeOrderModal && selectedPaymentMethod === 'online' && submitted_loader">
                    <i class="fa fa-spinner mr-5px" aria-hidden="true"></i>Yes, Sure online
                </button>
            </div>
        </div>
    </ng-template>
    <div class="content-body">
        <section id="cart">
            <div class="row">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <h2 class="mt-5px">Checkout</h2>
                </div>
            </div>
            <div class="row mt-20px">
                <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                    <div class="row">
                        <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                            <div class="card">
                                <div class="card-header shadow-bottom-light background-dark-blue">
                                    <h4 class="mt-5px color-white">
                                        <span class="background-white text-center mr-10px color-blue no-padding">
                                            1
                                        </span>
                                        <span>
                                            LOGIN
                                        </span>
                                        <span>
                                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                                        </span>
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <div class="row mt-20px">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h4 class="text-italic">{{userData?.name}}</h4>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h4 class="text-italic">{{userData?.username}}</h4>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h4 class="text-italic">{{userData?.contact}}</h4>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <h4 class="text-italic">{{userData?.email}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header shadow-bottom-light background-dark-blue">
                                    <h4 class="mt-5px color-white">
                                        <span class="background-white text-center mr-10px color-blue no-padding">
                                            2
                                        </span>
                                        <span>
                                            DELIVERY ADDRESS
                                        </span>
                                        <span>
                                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                                        </span>
                                    </h4>
                                </div>
                                <div class="card-body">
                                    <div class="row" *ngIf="addresses && addresses.length > 0">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <div class="row shadow-bottom-light p-20px deliver-address"
                                                 *ngFor="let address of addresses; let i = index">
                                                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-right">
                                                    <i class="fa fa-check-circle f_18 mt-5px cursor-pointer"
                                                       aria-hidden="true"
                                                       [ngClass]="{'text-success': address['selected']}"
                                                       (click)="chooseDeliveryAddress(address)"></i>
                                                </div>
                                                <div class="col-xl-9 col-lg-9 col-md-9 col-sm-9 col-xs-12">
                                                    <div class="row">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <span class="mr-10px f_18 text-italic font-weight-bold">{{address?.name}}</span>
                                                            <span class="f_18 text-italic font-weight-bold">{{address?.contact}}</span>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <span class="f_18 text-italic">{{address?.address}}</span>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <span class="f_18 text-italic">{{address?.city}}</span>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <span class="f_18 text-italic">{{address?.state?.name}}</span>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <span class="f_18 text-italic">{{address?.pin_code}}</span>
                                                        </div>
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="address?.gst_no">
                                                            <span class="f_18 text-italic">GSTIN- {{address?.gst_no}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="row mt-5px" *ngIf="address['selected']">
                                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                                            <button class="btn waves-effect waves-light"
                                                                    (click)="chooseAddressId()"
                                                                    [ngClass]="{'btn-success': addressId == address.id,
                                                                    'btn-warning': addressId != address.id
                                                                    }">
                                                                <i class="fa fa-location-arrow mr-10px"
                                                                   aria-hidden="true"></i>Deliver Here
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-right">
                                                    <div class="row">
                                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <h6 class="color-blue cursor-pointer"
                                                                (click)="openUpdateAddressModal(content, address)">
                                                                EDIT</h6>
                                                        </div>
                                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                                            <h6 class="text-danger cursor-pointer"
                                                                (click)="openDeleteAddressModal(content, address)">
                                                                DELETE</h6>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row mt-20px">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                                            <button class="btn btn-primary" (click)="openAddAddressModal(content)">
                                                <i class="fa fa-plus-circle mr-10px" aria-hidden="true"></i>Add Address
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="card">
                                <div class="card-header shadow-bottom-light background-dark-blue">
                                    <h4 class="mt-5px color-white">
                                        <span class="background-white text-center mr-10px color-blue no-padding">
                                            3
                                        </span>
                                        <span>
                                            ORDER SUMMARY
                                        </span>
                                        <span>
                                            <i class="fa fa-check-circle" aria-hidden="true"></i>
                                        </span>
                                    </h4>
                                </div>
                                <div class="card-body" *ngIf="addressId">
                                    <div class="row mt-20px">
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="f_13 text-italic font-weight-bold">S.No.</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="f_13 text-italic font-weight-bold">Remove</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Image</small>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Product Name</small>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Quantity</small>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">BV</small>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Price</small>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Tax</small>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Tax</small>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <small class="f_13 text-italic font-weight-bold">Total</small>
                                        </div>
                                    </div>
                                    <div class="row mt-20px shadow-top-light pt-20px"
                                         *ngFor="let cartProduct of cartProducts; let i = index">
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="f_12 text-italic font-weight-bold">{{i + 1}}.</span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <i class="fa fa-trash f_12 text-danger cursor-pointer" aria-hidden="true"
                                               title="Remove Product"
                                               (click)="removeFromCart(cartProduct)"></i>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <img class="border-radius-50-per"
                                                 [src]="imageBaseUrl+cartProduct?.product?.image?.partial_url"
                                                 width="30px" height="30px" [alt]="cartProduct?.name"/>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold text-italic f_12 cursor-pointer" *ngIf="cartProduct && cartProduct['quantity_available']">
                                                {{cartProduct?.name}}
                                            </span>
                                            <span class="font-weight-bold text-italic f_12 cursor-pointer text-danger" *ngIf="cartProduct && !cartProduct['quantity_available']">
                                                {{cartProduct?.name}}
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto text-center">
                                            <span class="font-weight-bold text-italic f_12">
                                                {{cartProduct?.quantity}}
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto text-center">
                                            <span class="font-weight-bold text-italic f_12">
                                                {{cartProduct?.basic_value * cartProduct?.quantity }}
                                            </span>
                                        </div>
                                        <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold text-italic f_12">
                                                &#8377;{{cartProduct?.amount | IndianNumber}}
                                                <small>(&#8377;{{cartProduct?.distributed_price | IndianNumber}}
                                                    / Unit)</small>
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold text-italic f_12 cursor-pointer">
                                                {{cartProduct?.tax}}%
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold text-italic f_12 cursor-pointer">
                                                &#8377;{{cartProduct?.tax_amount | IndianNumber}}
                                                <small>(&#8377;{{cartProduct?.unit_tax_amount | IndianNumber}}
                                                    / Unit)</small>
                                            </span>
                                        </div>
                                        <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-xs-12 text-center mt-auto mb-auto">
                                            <span class="font-weight-bold text-italic f_12">&#8377;{{cartProduct?.total_amount | IndianNumber}}</span>
                                        </div>
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center mt-auto mb-auto" *ngIf="cartProduct && !cartProduct['quantity_available']">
                                            <small class="text-danger text-italic blink_me">Quantity not available</small>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer" *ngIf="addressId">
                                    <div class="row">
                                        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 text-right">
                                            <button class="btn color-white waves-effect waves-light f_16 background-orange"
                                                    (click)="openPlaceOrderModal(content)">
                                                <i class="fa fa-check-circle mr-10px" aria-hidden="true"></i>Confirm &
                                                Place Order
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-xs-12">
                            <div class="card">
                                <div class="card-header shadow-bottom-light">
                                    <h5 class="text-italic font-weight-bold">PAYMENT DETAILS</h5>
                                </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <h5 class="mt-20px text-italic">Price ({{cartProducts.length}} Items)</h5>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <h5 class="mt-20px text-italic">
                                                &#8377;{{grandTotalAmount | IndianNumber}}</h5>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <h5 class="mt-20px text-italic">Delivery Charges</h5>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <h5 class="mt-20px text-italic">&#8377;0</h5>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <div class="row">
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                            <h4 class="text-italic font-weight-bold">Total Payable</h4>
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12 text-right">
                                            <h4 class="text-italic font-weight-bold">
                                                &#8377;{{grandTotalAmount | IndianNumber}}</h4>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</div>
